import Contacts from '../collections/Contacts';
import { baseApi } from 'core/api';

const state = () => ({
    _tagId: null,
    _tagContactsItems: null,
    _tagContactsPagination: {},
    _tagContactsParameters: {
        page: 1,
        sortBy: 'created_at',
        sortOrder: 'desc',
        search: null,
        limit: 10,
    },
    _loading: false,
    _loadingTag: false,
});

const getters = {
    tagContacts: (state) => state._tagContactsItems,
    tagContactsParameters: (state) => state._tagContactsParameters,
    tagContactsPagination: (state) => state._tagContactsPagination,
};

const actions = {
    tagContactsLoad(data = {}) {
        let idTag = this._tagId;
        const retry = Boolean(data.retry);

        if (this._loading) return;

        this._setTagContactsLoading(true);

        if (retry === true) {
            this._setTagContactsRetryLoading();
        }

        return baseApi
            .get(`core/contacts/tags/${idTag}`, { params: this._tagContactsParameters })
            .then((response) => {
                this._setTagContactsLoaded(response.data);

                return response;
            })
            .catch(() => {
                this._setTagContactsErrorLoading();
            })
            .finally(() => {
                this._setTagContactsLoading(false);
            });
    },

    tagContactsReset() {
        this._setTagContactsReset();
    },

    tagContactsUpdateSearch(search) {
        this._setTagContactsUpdateSearch(search);

        this.tagContactsLoad();
    },

    tagContactsUpdatePage(page) {
        this._setTagContactsUpdatePage(page);

        this.tagContactsLoad();
    },

    tagContactsUpdateSort(sort) {
        this._setTagContactsUpdateSort(sort);

        this.tagContactsLoad();
    },

    tagContactsCustomUpdateLengthSelector({ page: limit, data: page }) {
        this._setTagContactsUpdateLength({ limit, page });

        this.tagContactsLoad();
    },

    tagContactsClearSearch() {
        this._setTagContactsSearchCleared();

        this.tagContactsLoad();
    },

    getTagById(id) {
        if (this._loadingTag) return;

        this._setTagContactsTagLoading(true);
        this._setTagContactsId(id);

        return baseApi
            .get(`core/tags/${id}`).then((response) => {
                return response.data;
            })
            .finally(() => {
                this._setTagContactsTagLoading(false);
            });
    },

    // Private methods
    _setTagContactsTagLoading(status) {
        this._loadingTag = status;
    },

    _setTagContactsLoading(status) {
        this._loading = status;
    },

    _setTagContactsReset() {
        this._tagContactsItems = null;
    },

    _setTagContactsId(id) {
        this._tagId = id;
    },

    _setTagContactsLoaded(data) {
        const contacts = new Contacts(data.data);

        this._tagContactsItems = contacts.models;
        this._tagContactsPagination = {
            current_page: data.current_page,
            from: data.from,
            last_page: data.last_page,
            per_page: data.per_page,
            to: data.to,
            total: data.total,
            more: data.next_page_url
        };
    },

    _setTagContactsRetryLoading() {
        this._tagContactsItems = null;

        if (this._tagContactsPagination) {
            this._tagContactsPagination.total = 0;
        }
    },

    _setTagContactsErrorLoading() {
        this._tagContactsItems = false;

        if (this._tagContactsPagination) {
            this._tagContactsPagination.total = 0;
        }
    },

    _setTagContactsUpdateSearch(data) {
        this._tagContactsParameters.search = data;
    },

    _setTagContactsUpdatePage(data) {
        this._tagContactsParameters.page = data;
    },

    _setTagContactsUpdateLength(data) {
        this._tagContactsParameters.limit = data.limit;
        this._tagContactsParameters.page = data.page;
    },

    _setTagContactsSearchCleared() {
        this._tagContactsParameters.search = null;
    },

    _setContactUpdated({ contact }) {
        if (this._tagContactsItems === null) return;

        this._tagContactsItems = this._tagContactsItems.map((o) => {
            if (o.id === contact.id) {
                return contact;
            } else {
                return o;
            }
        });
    },

    _setContactDeleted({ id }) {
        if (this._tagContactsItems === null) {
            return;
        }

        this._tagContactsItems = this._tagContactsItems.filter((o) => o.id !== id);

        if (this._tagContactsPagination) {
            --this._tagContactsPagination.total;
        }
    },

    _setTagContactsUpdateSort(data) {
        this._tagContactsParameters.sortBy = data.sortBy;
        this._tagContactsParameters.sortOrder = data.sortOrder;
        this._tagContactsParameters.page = 1;
    },
};



export default {
    state,
    getters,
    actions,
};
